import { render, staticRenderFns } from "./StockMovementItems.vue?vue&type=template&id=97f4dc64&scoped=true&"
import script from "./StockMovementItems.vue?vue&type=script&lang=ts&"
export * from "./StockMovementItems.vue?vue&type=script&lang=ts&"
import style0 from "./StockMovementItems.vue?vue&type=style&index=0&id=97f4dc64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f4dc64",
  null
  
)

export default component.exports